import type { ReactNode } from "react";
import { windowStack } from "@/app/windowStack";
import { FullscreenWindow, type WindowEntry } from "@/components/modal";
import type { SessionDatasetsWindowParams } from "./sessionDatasetsWindow";
import { SessionDatasetsView, useSessionDatasetsController } from "./SessionDatasetsView";
import styles from "./SessionDatasetsWindowContent.module.css";

type SessionDatasetsWindowContentProps = {
  entry: WindowEntry;
  // 스택에서 이 엔트리가 전체 화면으로 보이는지. false 면 마운트는 유지하고 창은 접는다.
  active: boolean;
};

/**
 * Session 입력 Dataset 전체 화면 창. 세션 목록 Dataset 칸의 `외 N건` 이 연다.
 *
 * 목록 상태(controller)는 여기서 가진다. 최소화하면 셸이 본문을 언마운트한다. controller 가 본문
 * 안에 있으면 복원할 때마다 목록을 다시 받고 검색어와 선택을 잃는다(§12).
 */
export function SessionDatasetsWindowContent({
  entry,
  active,
}: SessionDatasetsWindowContentProps): ReactNode {
  const { sessionId } = entry.params as SessionDatasetsWindowParams;
  const controller = useSessionDatasetsController(sessionId, { enabled: active });

  return (
    <FullscreenWindow
      open={active}
      title={entry.title}
      titleBadge={<span className={styles.badge}>입력 Dataset</span>}
      bodyLayout="fill"
      onMinimize={() => windowStack.minimize(entry.id)}
      onBackdrop={() => windowStack.minimize(entry.id)}
      onRequestClose={() => windowStack.close(entry.id)}
    >
      <SessionDatasetsView controller={controller} />
    </FullscreenWindow>
  );
}
